<template>
  <div class>
    <div class="table-page-search-wrapper">
      <a-row :gutter="12" style="margin:16px 25px;">
         <a-col class="a-large-form" >
          <a-form-item label style="margin-bottom:0px;width:100%">
            <j-dict-select-tag v-model="queryParam.status" placeholder="全部评论状态" 
                 dictCode="comment_status" style="width:100%"/>
          </a-form-item>
          
        </a-col>
       
        <a-col class="a-large-form" >
          <a-form-item label style="margin-bottom:0px">
            <a-input placeholder="请输入昵称" v-model="queryParam.memberName" style="width:100%"></a-input>
          </a-form-item>
        </a-col>
        <a-button @click="searchQuery" type="primary" style="margin-left:5px;vertical-align: middle;">筛选</a-button>

        <a-col  style="float:right;padding-right:0px;">
          <span style="margin-bottom:0px" class="table-page-search-submitButtons">
            <!-- <span>
              <span style="vertical-align: middle;">课程评价</span>
              <a-tooltip placement="bottom">
                <template slot="title">
                  <span>课程评价提示</span>
                </template>
                <a-icon type="question-circle" style="vertical-align: middle;cursor: pointer;margin-left:5px;"/>
              </a-tooltip>
              <a-switch defaultChecked @change='onChange' style="margin-left:10px"/>
            </span> -->
            <!-- <a-button @click="exportData()" type="primary" icon="export" style="margin-left:13px;">导出记录</a-button> -->
            
          </span>
        </a-col>
      </a-row>
    </div>
    <div>
      <a-table
        ref="table"
        size="middle"
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="status" slot-scope="text, record">
          {{record.status=="0"?"待审核":(record.status=="1"?"审核通过":"审核不通过")}}
        </span>
        <span slot="action" slot-scope="text, record">

          <a @click="toReply(record.id)" >回复</a>
          
          <a-divider type="vertical" v-if="record.status=='0'"/>
          <a-popconfirm v-if="record.status=='0'" title="确定通过吗?" @confirm="() =>toShComment(record.id,1)">
            <a>审核通过</a>
          </a-popconfirm>
          <a-divider type="vertical" v-if="record.status=='0'"/>
          <a-popconfirm v-if="record.status=='0'" title="确定驳回吗?" @confirm="() => toShComment(record.id,2)">
            <a>审核驳回</a>
          </a-popconfirm>
          <a-divider type="vertical" />
          <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
            <a>删除评论</a>
          </a-popconfirm>

          <!-- <a @click="handleEdit(record)">编辑</a> -->

          <!-- <a-divider type="vertical" /> -->
          <!-- <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
   
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>编辑</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown> -->
        </span>

        <!-- <span slot="courseName" slot-scope="text, record">
          <span style='color:#333;font-size:14px;'>{record.courseName}</span>
          <span style='color:#999;font-size:12px;'>{record.time}</span>
        </span>-->
      </a-table>
    </div>
    <ReplyModal ref="replyModal" />
  </div>
</template>

<script>
import ReplyModal from '../ReplyModal'
import {courseConnect,courseCommon} from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'CourseRatingManage',
  mixins: [JeecgListMixin],
  components: {
    ReplyModal
  },
  data() {
    return {
      description: '课程评价',
      firstIsNotLoad:true,
      url: {
        list: "/course/common/listComment",
        delete: "/course/common/delete",
        // deleteBatch: "/course/elinkxCourse/deleteBatch",
        // exportXlsUrl: "course/elinkxCourse/exportXls",
        // importExcelUrl: "course/elinkxCourse/importExcel",
      },
      queryParam:{
        courseId:"",
        busiNo:"selectCommentByCourseId",
        // status:"",
        memberName:""
      },
      columns: [
        {
          title: '昵称',
          align: 'center',
          dataIndex: 'memberName',
          width: 200
        },
        {
          title: '评论内容',
          align: 'center',
          dataIndex: 'commentDetail',
          width: 120
        },
        
        {
          title: '评论时间',
          align: 'center',
          dataIndex: 'commentDate',
          width: 100
        },
        {
          title: '状态',
          align: 'center',
          dataIndex: 'status',
          width: 100,
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '回复内容',
          align: 'center',
          dataIndex: 'replyDetail',
          width: 100
        },
        {
          title: '回复时间',
          align: 'center',
          dataIndex: 'replyDate',
          width: 100
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          width: 300
        }
      ],
      dataSource: [
        
      ]
    }
  },
  created() {
    this.queryParam.courseId = this.$route.query.courseId
    this.loadData();
  },
  methods: {
    onChange:function(checked){
      // console.log(`a-switch to ${checked}`);
      
      courseCommon({busiNo:"openOrCloseComment",courseId:this.queryParam.courseId}).then((res)=>{
        if(res.success==true){
          this.$message.success(res.message);
        }else{
          this.$message.warning(res.message);
        }

      }).finally(() => {
        
      })
    },
    toReply:function(id){
      this.$refs.replyModal.add(id)
    },
    toShComment:function(id,status){
      courseConnect({busiNo:"updCourseComment",id:id,status:status}).then((res)=>{
        if(res.success==true){
          this.$message.success(res.message);
          this.loadData();
        }else{
          this.$message.warning(res.message);
        }

      }).finally(() => {
        
      })
    }
    
  }
}
</script>

<style scoped>
  @import '~@assets/less/common.less';
</style>